'use client';
import { SectionContent } from "@/types/sections.model";
import { Box, Container, Grid, Typography } from "@mui/material";
import Row from "../ui/Row";
import Image from "next/image";
import FadeIn from "../ui/FadeIn";
import { motion } from 'framer-motion';
import { useWindowSize } from "@/hook/useWindowSize";

const Hero: React.FC<{ section: SectionContent<'hero'> }> = ({ section }) => {

  const { id, content } = section;

  const { isMobile } = useWindowSize();

  return (
    <Box id={id} sx={{ position: 'relative', height: { xs: 'calc(100vh - 90px)', lg: 'calc(100dvh - 120px)' }, overflow: 'hidden' }}>

      <motion.div
        initial={{ clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)' }}
        animate={{ clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' }}
        transition={{ 
          duration: 1.5,
          ease: "easeInOut",
          delay: 0.3
        }}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}
      >
        <Image
          src={isMobile ? content.imageMobile : content.image}
          alt={content.title || 'Hero Image'}
          fill
          style={{ objectFit: 'cover', objectPosition: '0 30%' }}
          priority
        />
      </motion.div>

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 1,
          background: {
            xs: 'linear-gradient(270deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.20) 79.31%), linear-gradient(180deg, rgba(106, 22, 126, 0.00) 29.59%, rgba(0, 0, 0, 0.50) 100%)',
            lg: 'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%)'
          },
        }}
      />

      <Box
        sx={{
          color: 'white',
          height: '100%',
          // height: { xs: 'calc(100vh - 92px)', lg: 'calc(100dvh - 120px)' },
          display: 'flex',
          alignItems: {xs: 'flex-end', lg: 'center'},
          position: 'relative',
          zIndex: 2,
          py: { xs: 24, lg: 0}
        }}
      >
        <Container>
          <Row>
            <Grid size={{xs: 12, lg:6}}>
              {content.title && (
                <FadeIn>
                  <Typography variant="displayLG" component={"h1"} mb={{xs: 8, lg: 12}}>{content.title}</Typography>
                </FadeIn>
              )}
              {content.subtitle && (
                <FadeIn transition={{ delay: 0.2 }}>
                  <Typography variant="headlineMDMedium" component={"p"}>{content.subtitle}</Typography>
                </FadeIn>
              )}
            </Grid>
          </Row>
        </Container>
      </Box>      
    </Box>
  )
}

export default Hero;